import React from 'react';
import ProfileContainer from '../../containers/profilemng/ProfileContainer';

const ProfileViewPage = () => {
  return <ProfileContainer/>
};

export default ProfileViewPage;
